<template>
  <header :class="{ hidden: isHidden }">
    <div class="container">
      <div class="logo"><img src="../assets/logo.png" style="max-height: 40px;"></div>
      <nav>
        <ul>
          <li class="desktop-only"><a href="/#features" class="nav-button">Features</a></li>
          <li class="desktop-only"><a href="/#pricing" class="nav-button">Pricing</a></li>
      <!--    <li class="desktop-only"><a href="/#testimonials" class="nav-button">Testimonials</a></li>-->
          <li><a href="https://gigtrick.onepage.me/" class="cta-button">Sign Up</a></li>
        </ul>
      </nav>
    </div>
  </header>
</template>

<script>
export default {
  name: "HeaderComponent",
  props: {
    isHidden: {
      type: Boolean,
      required: true,
    },
  },
};
</script>

<style scoped>
header {
  background: #1a1a1a;
  color: #fff;
  padding: 1rem 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1000;
  transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1); /* Smooth transition */
}

header.hidden {
  transform: translateY(-100%); /* Slide the header out of view */
}

.container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 1rem 0rem 1rem;
}

nav ul {
  list-style: none;
  display: flex;
  gap: 1rem;
  padding: 0;
  margin: 0;
}

.nav-button {
  background-color: #3a3a3a;
  color: white;
  text-decoration: none;
  padding: 0.5rem 1rem;
  border-radius: 5px;
  font-size: 0.9rem;
  transition: background-color 0.3s ease, transform 0.3s ease;
}

.nav-button:hover {
  background-color: #ff5a5f; /* Highlight color for hover */
  transform: translateY(-2px); /* Lift effect */
}

.cta-button {
  background-color: var(--main-color); /* Neon pink for primary CTA */
  color: white;
  text-decoration: none;
  padding: 0.6rem 1.2rem;
  border-radius: 5px;
  font-weight: bold;
  transition: background-color 0.3s ease, transform 0.3s ease;
}

.cta-button:hover {
  background-color: #e60073; /* Slightly darker pink on hover */
  transform: translateY(-2px); /* Lift effect */
}

/* Hide navigation links on small screens */
@media (max-width: 768px) {
  .desktop-only {
    display: none;
  }
  .container {
    padding: 1rem;
  }
}
</style>
